export class BasketItemDirectives {
  itemId: number | null = 0;
  productId: number | null = 0;
  contentId: number | null = 0;
  broadcasterId: number | null = 0;
  manualTaskTemplateId: number | null = 0;
  includeOnlyAvailableValues: boolean | null = null;

  constructor(init?: Partial<BasketItemDirectives>) {
    Object.assign(this, init);
  }
}
